




import { TMS_ENABLED_CARRIERS_LAST_DIGITS, VUE_APP_TMS_URL } from '@/config'
import { fetchCarrierInvoicingTerms } from '@/services/payment-period-update'
import AuthenticatedPage from './AuthenticatedPage.vue'

export default {
  components: {
    AuthenticatedPage
  },
  data() {
    return {
      isTmsRedirectingEnabled: true
    }
  },
  computed: {
    isIframe() {
      return this.$route.query.iframe === 'true'
    },
    isOldOrcas() {
      return location.hostname.startsWith('old.')
    },
    shouldNotRedirect() {
      return this.isIframe || this.isOldOrcas
    },
    showPage() {
      return this.shouldNotRedirect || !this.isTmsRedirectingEnabled
    }
  },
  async created() {
    await this.redirectToTmsIfNeeded()
  },
  methods: {
    async redirectToTmsIfNeeded(): Promise<void> {
      if (this.shouldNotRedirect) {
        return
      }

      try {
        const carrierCompany = (await fetchCarrierInvoicingTerms()) as any
        if (this.isCarrierEligibleForRedirect(carrierCompany.id)) {
          window.location.assign(VUE_APP_TMS_URL)
        } else {
          this.isTmsRedirectingEnabled = false
        }
      } catch (e) {
        this.isTmsRedirectingEnabled = false
      }
    },
    isCarrierEligibleForRedirect(carrierId: number): boolean {
      const carrierIdLastDigit = carrierId % 10
      return TMS_ENABLED_CARRIERS_LAST_DIGITS.includes(String(carrierIdLastDigit))
    }
  }
}
